export default function persistMenu (store) {
  const STORAGE_KEY = 'app_menu'

  // TTL de 30 min - evitar que o menu fique desatualizado
  const TTL = 30 * 60 * 1000

  // escuta mutações e persiste se forem mutações na store menu
  store.subscribe((mutation, state) => {
    if (mutation.type === 'setMenu') {
      const menuWithTimestamp = {
        ...mutation.payload,
        timestamp: new Date().toISOString()
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(menuWithTimestamp))
    }
  })

  // carrega o menu salvo no localStorage e aplica na store menu
  const savedMenu = localStorage.getItem(STORAGE_KEY)
  if (savedMenu) {
    try {
      const parsedMenu = JSON.parse(savedMenu)
      const expired = Date.now() - new Date(parsedMenu.timestamp).getTime() > TTL
      if (expired) {
        localStorage.removeItem(STORAGE_KEY)
      } else {
        store.commit('setMenu', parsedMenu)
      }
    } catch (e) {
      localStorage.removeItem(STORAGE_KEY)
    }
  }
}
